interface ErrorObject {
  exception: string;
}

const isErrorObject = (error: unknown): error is ErrorObject =>
  typeof error === "object" && error !== null && "exception" in error;

export default isErrorObject;
